document.write('<link rel=\"STYLESHEET\" type=\"text/css\" href=\"//www.ti.com/en/css/shared/jquery-ui-1.7.2.custom.css\">' +
'<script language=\"JavaScript\" src=\'//www.ti.com/en/js/shared/jquery/contactform/jquery-ui-1.7.2.custom.min.js\' type=\"text/javascript\"></script>');
